import { css } from 'styled-components';

const sizes = {
  desktop: 1280,
  tablet: 1024,
  mobile: 812,
};

// Iterate through the sizes and create a media template
const media = Object.keys(sizes).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (min-width: ${sizes[label]}px) {
      ${css(...args)}
    }
  `;

  return acc;
}, {});

export { media, sizes };
